/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOrganizationIPWhitelistResponseData } from './CreateOrganizationIPWhitelistResponseData';
import {
    CreateOrganizationIPWhitelistResponseDataFromJSON,
    CreateOrganizationIPWhitelistResponseDataFromJSONTyped,
    CreateOrganizationIPWhitelistResponseDataToJSON,
    CreateOrganizationIPWhitelistResponseDataToJSONTyped,
} from './CreateOrganizationIPWhitelistResponseData';

/**
 * 
 * @export
 * @interface CreateOrganizationIPWhitelistResponse
 */
export interface CreateOrganizationIPWhitelistResponse {
    /**
     * 
     */
    data?: CreateOrganizationIPWhitelistResponseData;
}

/**
 * Check if a given object implements the CreateOrganizationIPWhitelistResponse interface.
 */
export function instanceOfCreateOrganizationIPWhitelistResponse(value: object): value is CreateOrganizationIPWhitelistResponse {
    return true;
}

export function CreateOrganizationIPWhitelistResponseFromJSON(json: any): CreateOrganizationIPWhitelistResponse {
    return CreateOrganizationIPWhitelistResponseFromJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationIPWhitelistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateOrganizationIPWhitelistResponseDataFromJSON(json['data']),
    };
}

export function CreateOrganizationIPWhitelistResponseToJSON(json: any): CreateOrganizationIPWhitelistResponse {
    return CreateOrganizationIPWhitelistResponseToJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistResponseToJSONTyped(value?: CreateOrganizationIPWhitelistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateOrganizationIPWhitelistResponseDataToJSON(value['data']),
    };
}

